
















import { Icon } from '@alpha/ink'
import icoLookup from '@/utilities/ico-lookup'
import { Vue, Component, Prop } from 'vue-property-decorator'
import * as db from '@shared/types/database'

@Component({
  components: {
    Icon
  }
})
export default class ExistingAssetPicker extends Vue {
  @Prop({ required: true }) readonly assets!: Record<string, db.Prototype>

  get imageTypeMap () {
    return icoLookup
  }

  openInNewWindow (asset: db.Prototype, event: Event) {
    event && event.stopPropagation()
    window.open(asset.url!)
  }
}
